import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getRouteApi } from '@tanstack/react-router';

import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { AUTH_REDIRECT_KEY } from '@/routes/(auth)/consts';

const route = getRouteApi('/auth/login');

const Login = () => {
  const { t } = useTranslation();
  const { redirect } = route.useSearch();

  const handleLogin = useCallback(() => {
    if (redirect) {
      sessionStorage.setItem(AUTH_REDIRECT_KEY, redirect);
    }
    window.location.href = `${import.meta.env.VITE_BACKEND_URL}/auth/microsoft`;
  }, [redirect]);

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('auth.login.title')}</CardTitle>
        <CardDescription>{t('auth.login.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <Button
          onClick={handleLogin}
          className='w-full'>
          {t('auth.login.microsoft')}
        </Button>
      </CardContent>
    </Card>
  );
};

export default Login;
